import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import OptionSection from 'src/js/modules/common/components/option-section';
import { imageFieldNames } from '../constants/field-names';

const { Box, InputGroupField } = designSystem;

const AltControl = ({ control, onChange, onInputClick }) => {
  const name = imageFieldNames.IMAGE_ALT;

  const handleChange = (value) => {
    onChange(value);
  };

  const handleInputClick = () => {
    onInputClick();
  };

  return (
    <OptionSection
      title={i18next.t('Alt title')}
      popoverProps={{
        content: i18next.t(
          'Search engines cannot see images but they can read their descriptions. Add image description to boost your search engine visibility.'
        ),
      }}
      bold
      wrap
    >
      <Box marginTop="spacing-2-xs">
        <InputGroupField
          name={name}
          control={control}
          placeholder={i18next.t('Enter image Alt title')}
          onChange={handleChange}
          onClick={handleInputClick}
        />
      </Box>
    </OptionSection>
  );
};

AltControl.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  onInputClick: PropTypes.func.isRequired,
};

export default AltControl;
